module.exports = __webpack_public_path__ + "img/princeton.ad5fae78.jpeg";